// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__EhhDR","jpCurrentDate":"JP_Footer_jpCurrentDate__bPRHt","jpFootage":"JP_Footer_jpFootage__6+FU8","higlight":"JP_Footer_higlight__tNQj-"};